(() => {
  const callback = () => {
    const MEDIUM_SCREEN_BREAKPOINT = 768;
    const TIMEOUT_DELAY = 50;

    const selectors = {
      menu: '.navigation-desktop__menu',
      menuLink: '.navigation-desktop__menu-link[data-content-id]',
      dropdown: '.navigation-desktop__dropdown',
      dropdownContent: '.navigation-desktop__dropdown-content',
    };

    const menu = document.querySelector(selectors.menu);
    const menuLinks = document.querySelectorAll(selectors.menuLink);
    const dropdown = document.querySelector(selectors.dropdown);
    const dropdownContents = document.querySelectorAll(selectors.dropdownContent);
    if (!menu || !dropdown) return;

    // Timeouts to delay opening and closing the dropdown preventing unintended switches
    // when accidentally hovering over another link
    let openTimeout, closeTimeout;

    const showDropdown = ({ contentId }) => {
      const isMediumScreen = window.matchMedia(`only screen and (max-width: ${MEDIUM_SCREEN_BREAKPOINT}px)`).matches;
      if (isMediumScreen) return;

      [...menuLinks, ...dropdownContents].forEach((element) => {
        const isSelected = element.dataset.contentId === contentId;
        element.classList.toggle('selected', isSelected);

        if (element.matches(selectors.menuLink)) {
          element.setAttribute('aria-expanded', isSelected ? 'true' : 'false');
        }

        if (element.matches(selectors.dropdownContent)) {
          element.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
        }
      });

      dropdown.classList.add('open');
    };

    const hideDropdown = () => {
      [...menuLinks, ...dropdownContents].forEach((element) => {
        if (element.matches(selectors.menuLink)) {
          element.setAttribute('aria-expanded', 'false');
          element.classList.remove('selected');
        }

        if (element.matches(selectors.dropdownContent)) element.setAttribute('aria-hidden', 'true');
      });

      dropdown.classList.remove('open');
    };

    // Manually trigger dropdown if a link is already hovered before mouse event listeners are attached
    const hoveredLink = menu.querySelector(`${selectors.menuLink}:hover`);
    if (hoveredLink) showDropdown({ contentId: hoveredLink.dataset.contentId });

    menu.addEventListener('mouseover', (event) => {
      const menuLink = event.target.closest(selectors.menuLink);
      const { contentId } = menuLink?.dataset ?? {};
      if (!contentId) return;

      clearTimeout(closeTimeout);

      openTimeout = setTimeout(() => showDropdown({ contentId }), TIMEOUT_DELAY);
    });

    menu.addEventListener('mouseout', (event) => {
      const menuLink = event.target.closest(selectors.menuLink);
      if (!menuLink) return;

      clearTimeout(openTimeout);

      const isDropdownHovered = event.relatedTarget?.closest(selectors.dropdown);
      if (!isDropdownHovered) closeTimeout = setTimeout(hideDropdown, TIMEOUT_DELAY);
    });

    dropdown.addEventListener('mouseenter', () => clearTimeout(closeTimeout));
    dropdown.addEventListener('mouseleave', () => (closeTimeout = setTimeout(hideDropdown, TIMEOUT_DELAY)));

    const showDropdownOnKey = (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        const menuLink = event.target.closest(selectors.menuLink);
        const { contentId } = menuLink?.dataset ?? {};
        if (!contentId) return;

        event.preventDefault();
        showDropdown({ contentId });

        // Delay trapping focus to ensure the dropdown is visible
        setTimeout(() => {
          const selectedContent = [...dropdownContents].find((element) => element.dataset.contentId === contentId);
          if (!selectedContent) return;

          const firstContentLink = selectedContent.querySelector('a');

          theme.a11y.trapFocus({
            container: selectedContent,
            elementToFocus: firstContentLink,
            namespace: 'selected_dropdown_content_focus',
          });
        }, 100);
      }
    };

    const hideDropdownOnKey = (event) => {
      if (event.key === 'Escape') {
        theme.a11y.removeTrapFocus({
          container: dropdown,
          namespace: 'selected_dropdown_content_focus',
        });

        const lastFocusedMenuLink = [...menuLinks].find((element) => element.classList.contains('selected'));
        hideDropdown();
        lastFocusedMenuLink?.focus();
      }
    };

    menu.addEventListener('keydown', showDropdownOnKey);
    dropdown.addEventListener('keydown', hideDropdownOnKey);
  };

  document.addEventListener('dynamic-section-rendering:navigation-dropdown-ds:rendered', callback);
})();
